import ExtraChargesInfo from './ExtraChargesInfo'

export default ExtraChargesInfo;
